export default function TreezIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101.333"
      height="101.333"
      version="1"
      viewBox="0 0 76 76"
    >
      <path
        d="M147 693c-4-3-7-24-7-45v-38h75c58 0 77-3 81-15 4-8-33-115-81-238-67-173-86-232-83-263l3-39h230l3 42 3 43h-54c-32 0-59 5-65 13-8 9 9 62 62 197 40 102 81 202 90 222 19 44 21 99 4 116-13 13-249 18-261 5z"
        transform="matrix(.1 0 0 -.1 0 76)"
      ></path>
    </svg>
  );
}
